let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("p1FD0")).then(() => parcelRequire('8vZ67'));